import {MaterialWithRecipes} from '@domain/materials'
import React from 'react'

import {useAnyPermission} from '../../../../permissions'
import {CHANGE_MATERIALS_PERMISSION_TYPES} from '../../../consts'
import {useGlobalMaterialsQuery} from '../../../hooks'

import {MaterialForm} from './MaterialForm'

import {Skeleton} from '@settings/modules/common/components/skeletons'
import {useAssetsQuery, useScheduleQuery} from '@settings/modules/common/hooks'

interface MaterialSettingsGeneralTabProps {
  material: MaterialWithRecipes | undefined
}

export const MaterialSettingsGeneralTab: React.FC<MaterialSettingsGeneralTabProps> = ({
  material
}) => {
  const canChangeMaterials = useAnyPermission(...CHANGE_MATERIALS_PERMISSION_TYPES)

  const {data: schedule} = useScheduleQuery()
  const {data: assets} = useAssetsQuery()

  const {data: globalMaterialOptions} = useGlobalMaterialsQuery(material?.type)
  if (!globalMaterialOptions) {
    throw new Error('BUG: global materials should be loaded before rendering general tab')
  }

  return assets && schedule ? (
    <MaterialForm
      material={material}
      key={material?.id ?? 'new'}
      isReadOnly={!canChangeMaterials}
      schedule={schedule}
      assets={assets}
      globalMaterialOptions={globalMaterialOptions}
    />
  ) : (
    <Skeleton
      height="15vh"
      sx={{
        backgroundColor: ({palette}) => palette.grey[200]
      }}
    />
  )
}
